// extracted by mini-css-extract-plugin
export default {"root":"Toast_root__ZUXgn","close":"Toast_close__fs3Qa","logRef":"Toast_logRef__Df27M","clone":"Toast_clone__KL7Sv"};